import { Routes } from '@angular/router';
import * as fromCore from './core';
import * as fromContract from './contract';
export const routes: Routes = [
  {
    path: '',
    redirectTo: '/contract-summary-search',
    // component: fromCore.HomeComponent,
    pathMatch: 'full'
  }, //	TODO: map to app component to redirect based upon user's identity
  {
    path: 'autologin',
    redirectTo: ''
  },
  { path: 'unauthorized', component: fromCore.UnauthorizedComponent },
  {
    path: 'contract-summary',
    canActivate: [fromContract.ContractGuard],
    component: fromContract.ContractSummaryComponent
  },
  {
    path: 'contract-summary-search',
    canActivate: [fromContract.ContractGuard],
    component: fromContract.ContractSummarySearchComponent
  },
  { path: '401', component: fromCore.UnauthorizedComponent },
  { path: '500', component: fromCore.UnexpectedErrorComponent },
  { path: '404', component: fromCore.NotFoundComponent },
  { path: '**', redirectTo: '/404' }
];
